<template>
  <div class="view-wrapper">
    <div class="form-fields">
      <h1>Logga in</h1>
      <div class="input-row">
        <label for="username">Användarnamn</label>
        <input id="unsername" v-model="username" type="text" name="username" />
      </div>
      <div class="input-row">
        <label for="username">Lösenord</label>
        <input
          id="password"
          v-model="password"
          type="password"
          name="password"
        />
      </div>
      <div class="input-row">
        <input type="submit" value="Logga in" @click="validate" />
      </div>
      <div v-if="error">
        <div class="error-message">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      error: false,
      errorMessage: ''
    };
  },
  methods: {
    validate() {
      this.error = false;
      this.errorMessage = '';

      this.$store
        .dispatch('auth/loginJWT', {
          userDetails: { username: this.username, password: this.password }
        })
        .then(() => {
          this.$router.push({ name: 'home' });
        })
        .catch(error => {
          for (const key in error) {
            //console.log(key, error[key]);
          }
          if (error.response) {
            const messages = error.response.data.message[0].messages;
            this.errorMessage = messages.map(mess => mess.message).join(', ');
            this.error = true;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-wrapper {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;

  label {
    display: block;
  }

  h1 {
    margin-bottom: 20px;
    margin-top: 0;
    padding: 0;
  }

  .form-fields {
    background-color: $white;
    max-width: 760px;
    padding: 40px;
    width: 100%;
  }

  .input-row {
    margin-bottom: 30px;
  }

  input[type='text'],
  input[type='password'] {
    appearance: none;
    border: 1px solid $beige;
    font-size: 18px;
    padding: 10px;
    width: 100%;
  }

  input[type='submit'] {
    appearance: none;
    background-color: $green;
    border: 0;
    border-radius: 40px;
    color: $white;
    cursor: pointer;
    font-size: 18px;
    min-height: 55px;
    min-width: 140px;
    outline: none;
    padding: 0 10px;
    text-align: center;
    user-select: none;
  }

  .error-message {
    color: $orange;
    font-weight: 600;
  }
}
</style>
